/* eslint-disable @angular-eslint/component-selector */
import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/es';  // Importa el locale español si lo necesitas
import { Turnos } from 'src/app/models/turnos';

@Component({
    selector: 'turno',
    templateUrl: './turno.component.html',
    styleUrls: ['./turno.component.scss'],
})
export class TurnoComponent implements OnInit {

    // #region Propiedades públicas
    @Input() turno: Turnos;
    // #endregion

    constructor() { }

    ngOnInit() { }

    /**
     * Devuelve los días de la semana de las fechas pasadas por parámetro
     * @param fecha 
     * @returns 
     */
    diaSemana(fecha: string[]): string {
        moment.locale('es');  // Configura el locale a español si lo necesitas
        
        // Si hay fechas, separar por comas y devolver los días de la semana
        if (fecha.length > 0) {
            return fecha.map(f => moment(f, 'YYYY-MM-DD').format('dddd').toUpperCase()).join(', ');
        }

        return '';
    }

}
